import { render, staticRenderFns } from "./AdminUpdate.vue?vue&type=template&id=6f1feb26&scoped=true&"
import script from "./AdminUpdate.vue?vue&type=script&lang=ts&"
export * from "./AdminUpdate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1feb26",
  null
  
)

export default component.exports